import { NavLink } from 'react-router'
import styled from 'styled-components'

export const PlainNavLink = styled(NavLink)`
  color: inherit;

  &:hover {
    text-decoration: none;
  }
`
